import { type ModuleData, ModuleProvider, useModule } from '#providers'
import { CollectionEnvelope } from '@monthio/react-components'
import { SavingsCapacityExtraordinaryItemGroupDto, TransactionOutputApplicantTransactionDto } from './SavingsCapacity.types'

interface SavingsCapacityConfig {
	getSessionTransactionsByCategories: (categoryIds: number[],
		amountFloor?: number) => Promise<CollectionEnvelope<TransactionOutputApplicantTransactionDto>>
}

interface SavingsCapacityData {}

export type SavingsCapacityModuleData = ModuleData<
	SavingsCapacityData,
	SavingsCapacityExtraordinaryItemGroupDto[],
	SavingsCapacityConfig
>

export const SavingsCapacityModuleProvider: typeof ModuleProvider<SavingsCapacityModuleData> =
	ModuleProvider

export const useSavingsCapacityModule: typeof useModule<SavingsCapacityModuleData> =
	useModule
